import { Skeleton, TableBodyCell, TableBodyRow } from "@aksara-ui/react";
import React from "react";

interface Props {
  rowsNumber: number;
  columnsNumber: number;
}

const TableBodyRowsSkeleton: React.FC<Props> = ({
  rowsNumber,
  columnsNumber,
}) => {
  return (
    <>
      {[...Array(rowsNumber)].map((row, index) => (
        <TableBodyRow key={index}>
          {[...Array(columnsNumber)].map((cell, index) => (
            <TableBodyCell key={index}>
              <Skeleton />
            </TableBodyCell>
          ))}
        </TableBodyRow>
      ))}
    </>
  );
};

export default TableBodyRowsSkeleton;
